import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=2670a6ca&scoped=true&"
import script from "./organization.vue?vue&type=script&lang=js&"
export * from "./organization.vue?vue&type=script&lang=js&"
import style0 from "./organization.vue?vue&type=style&index=0&lang=css&"
import style1 from "./organization.vue?vue&type=style&index=1&id=2670a6ca&scoped=true&lang=css&"
import style2 from "./organization.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670a6ca",
  null
  
)

export default component.exports